
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import UnitCollection from '../collections/UnitCollection'
import MapModelMixin from './mixins/MapModelMixin'

class UnitLayerModel extends Backbone.Model {
  
  initialize(attributes, options = {}) {
    let units = new UnitCollection(this.get('elements'), options)
    this.set({units})

    // Add models to collection of all unit models.

    if (options.mapModel) {
      options.mapModel.get('units').add(units.models)
    }

    // Add models to collection of all unit models within a level.

    if (options.levelModel) {
      options.levelModel.get('units').add(units.models)      
    }
  }
}

Cocktail.mixin(UnitLayerModel, MapModelMixin)

export default UnitLayerModel
